import type { Locale } from "@/lib/i18n";
import { pl, type WBlogPopularPostsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wBlogPopularPostsTranslations: Record<Locale, WBlogPopularPostsTranslations> = {
  pl,
  en,
  de,
};

export type { WBlogPopularPostsTranslations };
